import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Box, Mail, LogOut, LayoutDashboard, ShoppingCart } from "lucide-react";
import { Toaster } from "../../components/ui/sonner";

const links = [
  { to: "/admin", label: "Genel Bakış", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Siparişler", icon: ShoppingCart },
  { to: "/admin/products", label: "Ürünler", icon: Box },
  { to: "/admin/messages", label: "Mesajlar", icon: Mail },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="px-6 h-16 flex items-center border-b border-gray-200">
          <span className="w-7 h-7 bg-[#059669] flex items-center justify-center mr-2">
            <span className="text-white font-display text-[10px]">FD</span>
          </span>
          <span className="font-display tracking-tight text-sm">Yönetim Paneli</span>
        </div>
        <nav className="flex-1 py-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm font-medium border-l-2 ${
                  isActive
                    ? "border-[#059669] text-[#059669] bg-emerald-50"
                    : "border-transparent text-gray-700 hover:bg-gray-50"
                }`
              }
            >
              <l.icon size={16} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-gray-200 p-4">
          <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500">Giriş yaptınız</p>
          <p className="text-sm font-display truncate" data-testid="admin-user-email">{user.email}</p>
          <button
            onClick={handleLogout}
            data-testid="admin-logout"
            className="mt-3 w-full inline-flex items-center justify-center gap-2 border border-gray-300 px-3 py-2 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-black hover:text-white hover:border-black"
          >
            <LogOut size={12} /> Çıkış
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
        <Toaster position="top-right" />
      </main>
    </div>
  );
}
